import { HImg, JoinButton, Kicker, SpokesVideo, useCopy } from "./HelpersUI";

const Feature = ({ slot, title, body, i }) => (
  <article data-testid={`helpers-feature-${i}`} className="h-card h-rise overflow-hidden rounded-[2rem] bg-white" style={{ animationDelay: `${i * 90}ms` }}>
    <HImg slot={slot} alt={title} sizes="(min-width: 768px) 33vw, 100vw" className="aspect-[4/3] w-full" />
    <div className="p-7">
      <h3 className="h-display text-2xl font-bold text-[color:var(--h-ink)]">{title}</h3>
      <p className="mt-2 text-[15px] leading-relaxed text-slate-600">{body}</p>
    </div>
  </article>
);

export function HomePage({ join }) {
  const { c } = useCopy();
  return (
    <div data-testid="helpers-home">
      <section className="mx-auto grid max-w-7xl items-center gap-8 px-5 pb-16 pt-6 sm:px-8 lg:grid-cols-[1.05fr_1fr] lg:gap-16 lg:pb-24 lg:pt-16">
        <div className="h-rise order-2 lg:order-1">
          <Kicker>{c.hero_kicker}</Kicker>
          <h1 data-testid="helpers-hero-title" className="h-display text-4xl font-extrabold leading-[1.05] tracking-tight text-[color:var(--h-ink)] sm:text-5xl lg:text-6xl">{(c.hero_title || "").replace(/-/g, "\u2011")}</h1>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-slate-600 sm:text-lg">{c.hero_body}</p>
          <div className="mt-9 flex flex-wrap gap-3">
            <JoinButton testid="helpers-hero-join-button" onClick={() => join()}>{c.join_button}</JoinButton>
          </div>
        </div>
        <div className="relative order-1 lg:order-2">
          <div className="absolute -right-6 -top-6 h-40 w-40 rounded-full bg-[color:var(--h-peach)] opacity-70 blur-2xl" aria-hidden />
          <HImg slot="helpers_08_join" alt={c.hero_title} eager natural className="relative aspect-[4/3] w-full rounded-[2.5rem] lg:aspect-[4/5]" />
        </div>
      </section>

      <section className="bg-[color:var(--h-peach-soft)] py-16 lg:py-24">
        <div className="mx-auto grid max-w-7xl items-center gap-10 px-5 sm:px-8 lg:grid-cols-[1fr_1.4fr] lg:gap-16">
          <div>
            <h2 className="h-display text-3xl font-bold tracking-tight text-[color:var(--h-ink)] sm:text-4xl">{c.video_title}</h2>
            <p className="mt-4 max-w-md text-base leading-relaxed text-slate-600">{c.video_body}</p>
          </div>
          <SpokesVideo />
        </div>
      </section>

      <section className="mx-auto grid max-w-7xl gap-6 px-5 py-16 sm:px-8 md:grid-cols-3 lg:py-24">
        <Feature i={0} slot="helpers_01_elderly" title={c.care_title} body={c.care_body} />
        <Feature i={1} slot="helpers_03_kitchen" title={c.home_title} body={c.home_body} />
        <Feature i={2} slot="helpers_04_nursery" title={c.family_title} body={c.family_body} />
      </section>

      <section className="px-5 pb-20 sm:px-8 lg:pb-28">
        <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem]">
          <HImg slot="helpers_02_lawn" alt={c.band_title} sizes="100vw" className="aspect-[4/5] w-full sm:aspect-[21/9]" />
          <div className="absolute inset-x-4 bottom-4 rounded-[1.75rem] bg-white/90 p-7 backdrop-blur-md sm:inset-x-auto sm:bottom-8 sm:left-8 sm:max-w-md">
            <h2 className="h-display text-2xl font-bold text-[color:var(--h-ink)] sm:text-3xl">{c.band_title}</h2>
            <p className="mt-2 text-[15px] leading-relaxed text-slate-600">{c.band_body}</p>
          </div>
        </div>
      </section>
    </div>
  );
}
